import type { AxiosProgressEvent, CancelToken } from "axios";

import { getApi } from "@api/apiPath";
import type { IFile } from "@api/file/routeType";
import type { IPickMutation } from "@/api";
import { axiosClient } from "@api/clients.ts";

const { getPath } = getApi("file.post");

type IExtractedRouteType = IFile["fileSingleCreate"];

export type IPostFile = IPickMutation<IExtractedRouteType>;

export const postFile = (
  file: File,
  progressCallBack?: (progressEvent: AxiosProgressEvent) => void,
  cancelToken?: CancelToken,
): Promise<IPostFile["response"]> => {
  const data = new FormData();

  data.append("file", file);

  return axiosClient.post(getPath(), data, {
    onUploadProgress(progressEvent) {
      progressCallBack?.(progressEvent);
    },
    cancelToken,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
